<!-- Create / Update setup pages -->
<div  class="contentBox">
<h2 class="heading content-top">{{headerText}}</h2>
<section class="w-100">
    <form #buForm="ngForm">
        <div class="mt-10">
            <kendo-label text="Name"></kendo-label>
            <br>
            <kendo-textbox class="mt-5 w-25" name="fBuName" [required]="'required'" [(ngModel)]="BUname"
                [clearButton]="true"></kendo-textbox>
            <div *ngIf="hasNameError">
                <kendo-formerror>Please enter a business unit name</kendo-formerror>
            </div>
        </div>
        <div class="mt-10">
            <kendo-label text="Short Name"></kendo-label>
            <br>
            <kendo-textbox class="mt-5 w-25" name="fShortName" [required]="hasShortNameError" [(ngModel)]="shortName"
                [clearButton]="true"></kendo-textbox>
            <div *ngIf="hasShortNameError">
                <kendo-formerror>Please enter a business unit code</kendo-formerror>
            </div>
        </div>
        <div class="mt-10">
            <kendo-label text="Is Active"></kendo-label>
            <br>
            <input class="checkbox" type="checkbox" #isActiveCheck id="isActiveCheck" [checked]="isActive"
                (change)="activeChanged(isActiveCheck.checked)" />
        </div>
        <div class="text-right">
            <button kendoButton class="border-button mr-20" (click)="cancel()">Cancel</button>
            <button kendoButton class="primary-button" (click)="save()">Save</button>
        </div>
    </form>
</section>
</div>